import React, { useState, useEffect, useRef } from 'react';
import Layout from '../../components/Layout';

const ExamCellAdmitFormat = ({ onNavigate, userInfo, studentData }) => {
    const printRef = useRef(null);

    // State Management
    const [isMobile, setIsMobile] = useState(false);
    const [editingField, setEditingField] = useState(null);
    const [hoveredField, setHoveredField] = useState(null);

    // Default mock student data - now editable
    const [formData, setFormData] = useState({
        admitNo: 'SVU/ODD/23-24/4828',
        name: 'NILADRI SEKHAR MAJI',
        semester: 'III',
        department: 'B.Tech in Computer Science & Engineering',
        registrationNumber: 'NA',
        rollNumber: '002-BCS-2022-387',
        photo: null,
        examTitle: 'ODD Semester Examinations (Under CBCS/ NEP/ Non-NEP Curriculum), 2023',
        universityName: 'SWAMI VIVEKANANDA UNIVERSITY',
        examSchedule: [
            {
                date: '15-01-2024',
                paperName: 'ECONOMICS FOR ENGINEERS(HUMANITIES-II)',
                paperCode: 'HU301',
                semester: 'III',
                time: '02:00 PM - 04:30 PM'
            },
            {
                date: '16-01-2024',
                paperName: 'ANALOG AND DIGITAL ELECTRONICS',
                paperCode: 'BTCSC301',
                semester: 'III',
                time: '02:00 PM - 04:30 PM'
            },
            {
                date: '17-01-2024',
                paperName: 'DATA STRUCTURE &ALGORITHMS',
                paperCode: 'BTCSC302',
                semester: 'III',
                time: '02:00 PM - 04:30 PM'
            },
            {
                date: '18-01-2024',
                paperName: 'COMPUTER ORGANIZATION',
                paperCode: 'BTCSC303',
                semester: 'III',
                time: '02:00 PM - 04:30 PM'
            },
            {
                date: '19-01-2024',
                paperName: 'MATHEMATICS - III',
                paperCode: 'BTCSG301',
                semester: 'III',
                time: '02:00 PM - 04:30 PM'
            }
        ]
    });

    // Effects
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);



    const handlePrint = () => {
        window.print();
    };

    // Editable field handlers
    const handleFieldChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        // Auto-save simulation
        console.log('Auto-saving:', field, value);
    };

    const handleScheduleChange = (index, field, value) => {
        const newSchedule = [...formData.examSchedule];
        newSchedule[index] = {
            ...newSchedule[index],
            [field]: value
        };
        setFormData(prev => ({
            ...prev,
            examSchedule: newSchedule
        }));
        console.log('Auto-saving schedule:', index, field, value);
    };

    const addScheduleRow = () => {
        setFormData(prev => ({
            ...prev,
            examSchedule: [...prev.examSchedule, {
                date: '',
                paperName: '',
                paperCode: '',
                semester: '',
                time: ''
            }]
        }));
    };

    const deleteScheduleRow = (index) => {
        setFormData(prev => ({
            ...prev,
            examSchedule: prev.examSchedule.filter((_, i) => i !== index)
        }));
    };

    // Editable Text Component
    const EditableText = ({ value, onChange, field, style = {}, multiline = false }) => {
        const [isEditing, setIsEditing] = useState(false);
        const [tempValue, setTempValue] = useState(value);
        const inputRef = useRef(null);

        useEffect(() => {
            if (isEditing && inputRef.current) {
                inputRef.current.focus();
                if (!multiline) {
                    inputRef.current.select();
                }
            }
        }, [isEditing, multiline]);

        const handleSave = () => {
            onChange(tempValue);
            setIsEditing(false);
        };

        const handleKeyDown = (e) => {
            if (e.key === 'Enter' && !multiline) {
                handleSave();
            } else if (e.key === 'Escape') {
                setTempValue(value);
                setIsEditing(false);
            }
        };

        return (
            <div
                style={{
                    position: 'relative',
                    display: 'inline-block',
                    ...style
                }}
                onMouseEnter={() => setHoveredField(field)}
                onMouseLeave={() => setHoveredField(null)}
            >
                {isEditing ? (
                    multiline ? (
                        <textarea
                            ref={inputRef}
                            value={tempValue}
                            onChange={(e) => setTempValue(e.target.value)}
                            onBlur={handleSave}
                            onKeyDown={handleKeyDown}
                            style={{
                                ...style,
                                border: '2px solid #238548',
                                outline: 'none',
                                background: '#fffef0',
                                width: '100%',
                                minHeight: '60px',
                                resize: 'vertical'
                            }}
                        />
                    ) : (
                        <input
                            ref={inputRef}
                            type="text"
                            value={tempValue}
                            onChange={(e) => setTempValue(e.target.value)}
                            onBlur={handleSave}
                            onKeyDown={handleKeyDown}
                            style={{
                                ...style,
                                border: '2px solid #238548',
                                outline: 'none',
                                background: '#fffef0'
                            }}
                        />
                    )
                ) : (
                    <span style={style}>{value}</span>
                )}

                {!isEditing && hoveredField === field && (
                    <button
                        onClick={() => {
                            setIsEditing(true);
                            setTempValue(value);
                        }}
                        className="no-print"
                        style={{
                            position: 'absolute',
                            top: '-8px',
                            right: '-8px',
                            background: '#238548',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            zIndex: 10
                        }}
                    >
                        ✎
                    </button>
                )}
            </div>
        );
    };

    return (
        <Layout role="examcell" onNavigate={onNavigate} userInfo={userInfo} activePage="examcell-admitformat">
            <style>
                {`
                    @media print {
                        body * {
                            visibility: hidden;
                        }
                        .print-area, .print-area * {
                            visibility: visible;
                        }
                        .print-area {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                        }
                        .no-print {
                            display: none !important;
                        }
                        @page {
                            size: A4;
                            margin: 10mm;
                        }
                    }
                `}
            </style>
            {/* Print Button */}
            <div style={{
                marginBottom: '1.5rem',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '1rem',
                alignItems: 'center'
            }}>
                <div style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2d3748' }}>
                    Editable Admit Card Format (Hover to Edit)
                </div>
                <div style={{ display: 'flex', gap: '1rem' }}>
                    <button onClick={addScheduleRow} style={{
                        padding: '0.75rem 1.5rem',
                        background: '#4299e1',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        boxShadow: '0 4px 6px rgba(66, 153, 225, 0.2)',
                        transition: 'all 0.3s'
                    }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = '#3182ce'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = '#4299e1'; }}
                    >
                        ➕ Add Row
                    </button>
                    <button onClick={handlePrint} style={{
                        padding: '0.75rem 1.5rem',
                        background: '#238548',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        boxShadow: '0 4px 6px rgba(35, 133, 72, 0.2)',
                        transition: 'all 0.3s'
                    }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = '#1a5a33'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = '#238548'; }}
                    >
                        🖨️ Print Admit Card
                    </button>
                </div>
            </div>

            {/* Admit Card - A4 Size */}
            <div className="print-area" ref={printRef} style={{
                width: '210mm',
                minHeight: '297mm',
                maxWidth: '210mm',
                margin: '0 auto',
                background: '#e8f0dc',
                padding: '20mm',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                position: 'relative',
                fontFamily: "'Times New Roman', Times, serif",
                borderRadius: '8px',
                boxSizing: 'border-box'
            }}>
                {/* Document Number */}
                <div style={{
                    position: 'absolute',
                    top: '15mm',
                    left: '20mm',
                    fontSize: '0.9rem',
                    color: '#333',
                    fontWeight: '500'
                }}>
                    No.: <EditableText
                        value={formData.admitNo}
                        onChange={(val) => handleFieldChange('admitNo', val)}
                        field="admitNo"
                    />
                </div>

                {/* University Header */}
                <div style={{
                    textAlign: 'center',
                    marginBottom: '2rem'
                }}>
                    {/* University Logo */}
                    <div style={{
                        width: '100px',
                        height: '100px',
                        margin: '0 auto 1rem',
                        borderRadius: '50%',
                        background: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '3px solid #238548'
                    }}>
                        <img src="/logo.png" alt="University Logo" style={{
                            width: '90px',
                            height: '90px',
                            objectFit: 'contain'
                        }} />
                    </div>

                    <h1 style={{
                        fontSize: '1.8rem',
                        fontWeight: 'bold',
                        margin: '0 0 0.5rem 0',
                        color: '#000',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase'
                    }}>
                        <EditableText
                            value={formData.universityName}
                            onChange={(val) => handleFieldChange('universityName', val)}
                            field="universityName"
                            style={{ fontSize: '1.8rem', fontWeight: 'bold' }}
                        />
                    </h1>

                    <h2 style={{
                        fontSize: '1.4rem',
                        fontWeight: 'bold',
                        margin: '0.5rem 0',
                        color: '#000',
                        textDecoration: 'underline'
                    }}>
                        ADMIT
                    </h2>

                    <p style={{
                        fontSize: '1rem',
                        margin: '0.5rem 0 0 0',
                        color: '#333',
                        fontWeight: '500'
                    }}>
                        <EditableText
                            value={formData.examTitle}
                            onChange={(val) => handleFieldChange('examTitle', val)}
                            field="examTitle"
                            multiline={true}
                            style={{ fontSize: '1rem', width: '100%' }}
                        />
                    </p>
                </div>

                {/* Student Details Section */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '2rem',
                    marginBottom: '2rem',
                    padding: '1.5rem 0',
                    borderRadius: '8px'
                }}>
                    {/* Left: Student Details - One field per row */}
                    <div>
                        {/* Name */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto auto 1fr',
                            gap: '0.5rem',
                            padding: '0.5rem 0',
                            borderBottom: '1px solid rgba(0,0,0,0.1)',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                fontWeight: '600',
                                color: '#000',
                                fontSize: '0.9rem'
                            }}>
                                Name of the Candidate
                            </div>
                            <div style={{ color: '#000' }}>:</div>
                            <div style={{
                                color: '#000',
                                fontWeight: '500',
                                fontSize: '0.9rem'
                            }}>
                                <EditableText
                                    value={formData.name}
                                    onChange={(val) => handleFieldChange('name', val)}
                                    field="name"
                                />
                            </div>
                        </div>

                        {/* Semester */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto auto 1fr',
                            gap: '0.5rem',
                            padding: '0.5rem 0',
                            borderBottom: '1px solid rgba(0,0,0,0.1)',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                fontWeight: '600',
                                color: '#000',
                                fontSize: '0.9rem'
                            }}>
                                Semester
                            </div>
                            <div style={{ color: '#000' }}>:</div>
                            <div style={{
                                color: '#000',
                                fontWeight: '500',
                                fontSize: '0.9rem'
                            }}>
                                <EditableText
                                    value={formData.semester}
                                    onChange={(val) => handleFieldChange('semester', val)}
                                    field="semester"
                                />
                            </div>
                        </div>

                        {/* Department */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto auto 1fr',
                            gap: '0.5rem',
                            padding: '0.5rem 0',
                            borderBottom: '1px solid rgba(0,0,0,0.1)',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                fontWeight: '600',
                                color: '#000',
                                fontSize: '0.9rem'
                            }}>
                                Department
                            </div>
                            <div style={{ color: '#000' }}>:</div>
                            <div style={{
                                color: '#000',
                                fontWeight: '500',
                                fontSize: '0.9rem'
                            }}>
                                <EditableText
                                    value={formData.department}
                                    onChange={(val) => handleFieldChange('department', val)}
                                    field="department"
                                />
                            </div>
                        </div>

                        {/* Registration Number */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto auto 1fr',
                            gap: '0.5rem',
                            padding: '0.5rem 0',
                            borderBottom: '1px solid rgba(0,0,0,0.1)',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                fontWeight: '600',
                                color: '#000',
                                fontSize: '0.9rem'
                            }}>
                                Registration Number
                            </div>
                            <div style={{ color: '#000' }}>:</div>
                            <div style={{
                                color: '#000',
                                fontWeight: '500',
                                fontSize: '0.9rem'
                            }}>
                                <EditableText
                                    value={formData.registrationNumber}
                                    onChange={(val) => handleFieldChange('registrationNumber', val)}
                                    field="registrationNumber"
                                />
                            </div>
                        </div>

                        {/* Roll Number */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto auto 1fr',
                            gap: '0.5rem',
                            padding: '0.5rem 0',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                fontWeight: '600',
                                color: '#000',
                                fontSize: '0.9rem'
                            }}>
                                Roll Number
                            </div>
                            <div style={{ color: '#000' }}>:</div>
                            <div style={{
                                color: '#000',
                                fontWeight: '500',
                                fontSize: '0.9rem'
                            }}>
                                <EditableText
                                    value={formData.rollNumber}
                                    onChange={(val) => handleFieldChange('rollNumber', val)}
                                    field="rollNumber"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Right: Student Photo - Standard Passport Size (35mm x 45mm) */}
                    <div style={{
                        position: 'relative'
                    }}>
                        <div style={{
                            width: '35mm',
                            height: '45mm',
                            border: '2px solid #000',
                            background: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: 'auto',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            {formData.photo ? (
                                <img src={formData.photo} alt="Student" style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                }} />
                            ) : (
                                <div style={{ color: '#999', fontSize: '0.8rem', textAlign: 'center', padding: '0.5rem' }}>
                                    35mm × 45mm<br />Photo
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Schedule Table */}
                <div style={{
                    marginBottom: '2rem'
                }}>
                    <h3 style={{
                        textAlign: 'center',
                        background: '#fff',
                        padding: '0.75rem',
                        margin: '0 0 1rem 0',
                        border: '2px solid #000',
                        borderRadius: '4px',
                        fontSize: '1.1rem',
                        fontWeight: 'bold',
                        color: '#000',
                        letterSpacing: '0.05em'
                    }}>
                        SCHEDULE FOR SEMESTER EXAMINATIONS**
                    </h3>

                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        border: '2px solid #000',
                        background: '#fff'
                    }}>
                        <thead>
                            <tr style={{ background: '#f0f0f0' }}>
                                <th style={{
                                    border: '1px solid #000',
                                    padding: '0.75rem',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    fontSize: '0.95rem'
                                }}>
                                    DATE
                                </th>
                                <th style={{
                                    border: '1px solid #000',
                                    padding: '0.75rem',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    fontSize: '0.95rem'
                                }}>
                                    NAME OF THE PAPER
                                </th>
                                <th style={{
                                    border: '1px solid #000',
                                    padding: '0.75rem',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    fontSize: '0.9rem',
                                    width: '100px'
                                }}>
                                    PAPER<br />CODE
                                </th>
                                <th style={{
                                    border: '1px solid #000',
                                    padding: '0.75rem',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    fontSize: '0.95rem',
                                    width: '100px'
                                }}>
                                    SEMESTER
                                </th>
                                <th style={{
                                    border: '1px solid #000',
                                    padding: '0.75rem',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    fontSize: '0.95rem',
                                    width: '120px'
                                }}>
                                    TIME
                                </th>
                                <th style={{
                                    border: '1px solid #000',
                                    padding: '0.75rem',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    fontSize: '0.85rem',
                                    width: '150px'
                                }}>
                                    Full Signature of<br />Invigilator with<br />Date
                                </th>
                                <th className="no-print" style={{
                                    border: '1px solid #000',
                                    padding: '0.75rem',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    fontSize: '0.85rem',
                                    width: '60px'
                                }}>
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {formData.examSchedule.map((exam, index) => (
                                <tr key={index}>
                                    <td style={{
                                        border: '1px solid #000',
                                        padding: '0.75rem',
                                        textAlign: 'center',
                                        color: '#000',
                                        fontWeight: '500'
                                    }}>
                                        <EditableText
                                            value={exam.date}
                                            onChange={(val) => handleScheduleChange(index, 'date', val)}
                                            field={`date-${index}`}
                                        />
                                    </td>
                                    <td style={{
                                        border: '1px solid #000',
                                        padding: '0.75rem',
                                        textAlign: 'left',
                                        color: '#000',
                                        fontWeight: '500'
                                    }}>
                                        <EditableText
                                            value={exam.paperName}
                                            onChange={(val) => handleScheduleChange(index, 'paperName', val)}
                                            field={`paperName-${index}`}
                                        />
                                    </td>
                                    <td style={{
                                        border: '1px solid #000',
                                        padding: '0.75rem',
                                        textAlign: 'center',
                                        color: '#000',
                                        fontWeight: '500'
                                    }}>
                                        <EditableText
                                            value={exam.paperCode}
                                            onChange={(val) => handleScheduleChange(index, 'paperCode', val)}
                                            field={`paperCode-${index}`}
                                        />
                                    </td>
                                    <td style={{
                                        border: '1px solid #000',
                                        padding: '0.75rem',
                                        textAlign: 'center',
                                        color: '#000',
                                        fontWeight: '500'
                                    }}>
                                        <EditableText
                                            value={exam.semester}
                                            onChange={(val) => handleScheduleChange(index, 'semester', val)}
                                            field={`semester-${index}`}
                                        />
                                    </td>
                                    <td style={{
                                        border: '1px solid #000',
                                        padding: '0.75rem',
                                        textAlign: 'center',
                                        color: '#000',
                                        fontWeight: '500',
                                        fontSize: '0.9rem'
                                    }}>
                                        <EditableText
                                            value={exam.time}
                                            onChange={(val) => handleScheduleChange(index, 'time', val)}
                                            field={`time-${index}`}
                                        />
                                    </td>
                                    <td style={{
                                        border: '1px solid #000',
                                        padding: '0.75rem',
                                        background: '#fafafa'
                                    }}>
                                    </td>
                                    <td className="no-print" style={{
                                        border: '1px solid #000',
                                        padding: '0.5rem',
                                        textAlign: 'center'
                                    }}>
                                        <button
                                            onClick={() => deleteScheduleRow(index)}
                                            style={{
                                                background: '#e53e3e',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '0.25rem 0.5rem',
                                                cursor: 'pointer',
                                                fontSize: '0.8rem'
                                            }}
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Footer */}
                <div style={{
                    marginTop: '3rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end'
                }}>
                    {/* Subject to changes note */}
                    <div>
                        <p style={{
                            fontSize: '0.9rem',
                            color: '#000',
                            fontWeight: '600',
                            margin: 0
                        }}>
                            **Subject to unavoidable changes
                        </p>
                    </div>

                    {/* Controller signature */}
                    <div style={{
                        textAlign: 'center',
                        minWidth: '200px'
                    }}>
                        <div style={{
                            height: '60px',
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'center',
                            marginBottom: '0.5rem'
                        }}>
                            {/* Signature placeholder */}
                            <div style={{
                                fontFamily: 'cursive',
                                fontSize: '1.5rem',
                                color: '#333'
                            }}>

                            </div>
                        </div>
                        <div style={{
                            borderTop: '2px solid #000',
                            paddingTop: '0.5rem',
                            fontWeight: '600',
                            color: '#000'
                        }}>
                            Controller of Examinations
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ExamCellAdmitFormat;
